var map = {
	"./pin.png": "8b54",
	"./smile-face.png": "c0ce",
	"./sparkles.png": "1a69",
	"./telephone.png": "00d6",
	"./waving.png": "da7d",
	"./website.png": "2614"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "92b5";